import React, { FC } from "react";

import "./ModalWrapper.scss";

import useAppStore from "../Store/AppStore";
import Menu from "./Menu";
import Feedback from "./Feedback";
import Thankyou from "./Thankyou";
import NoGroupAssigned from "./NoGroupAssigned";

const ModalPopup: FC = () => {
  const modalPopupIsOpen = useAppStore((state) => state.modalPopupIsOpen);
  const popupName = useAppStore((state) => state.currentPopup);

  let popupComponent;

  switch (popupName) {
    case "menu":
      popupComponent = <Menu />;
      break;
    case "feedback":
      popupComponent = <Feedback />;
      break;
    case "thankyou":
      popupComponent = <Thankyou />;
      break;
    case "noGroupAssigned":
      popupComponent = <NoGroupAssigned />;
      break;
    default:
      popupComponent = null;
  }

  return (
    <div className={`menupopup ${modalPopupIsOpen ? "block" : "hidden"}`}>
      <div className="h-full w-full flex items-center justify-center">
        {popupComponent}
      </div>
    </div>
  );
};

export default ModalPopup;
